import { Middleware } from "redux";
import { INIT_APPLICATION_STARTED, FETCH_TIMINGS_SUCCEEDED, FETCH_BOOKMAKER_OPTIONS_SUCCEDED, FETCH_TRANSLATIONS_SUCCEEDED, INIT_APPLICATION_FINISHED, INIT_APPLICATION_FAILED, FETCH_BOOKMAKER_OPTIONS_REQUESTED, FETCH_BOOKMAKER_OPTIONS_FAILED, FETCH_MATCH_EVENTS_SUCCEEDED, FETCH_MATCH_DETAILS_EXTENDED_SUCCEEDED, FETCH_MATCH_ODDS_SUCCEEDED, FETCH_STATS_RANKING_REQUESTED, FETCH_STATS_PLAYER_AGGREGATE_REQUESTED, FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED, FETCH_STATS_TEAM_LAST_X_REQUESTED } from "../actions/actionTypes";
import { getBaseUrl, getClientId, getStyle, getApplicationBaseUrl, getPollInactiveChannels, getSkinningsUrl } from "../reducers/config";
import { addStyles } from '../utils/injectAssets';
import { promiseBookmakerOptions, promiseTranslations, promiseMatchEvents, promiseMatchDetailsExtended } from '../api/feedPromises';
import { IState } from '../store/state';
import { getMatchIds, getChannelIdByMatchId } from "../reducers/timings";
import { getActiveChannelId } from "../reducers/gui";
import {getPlayerUidsByMatchId, getTournamentId, getUniqueTournamentId} from "../reducers/matches";
import { MiddlewareAPI } from "redux";
import { promiseMatchOddsValidated } from "../api/validatedFeedPromises";
import FeedBatch from "../utils/FeedBatch";

// a switch for waiting with promisechain at FETCH_BOOKMAKER_OPTIONS_SUCCEDED for timingsWebWorker having sent data message
let timingsWebWorkerResolver : any = false

const initializerMiddleware : Middleware = store => next => action => {
    const result = next(action);
    switch( action.type ) {
        case INIT_APPLICATION_STARTED:
            store.dispatch({type:FETCH_BOOKMAKER_OPTIONS_REQUESTED});
            break;
        case FETCH_TIMINGS_SUCCEEDED:
            // switch timingsWebWorkerResolver
            typeof timingsWebWorkerResolver==='function' ? timingsWebWorkerResolver() : timingsWebWorkerResolver = true
            break
        case FETCH_BOOKMAKER_OPTIONS_REQUESTED:
            promiseBookmakerOptions(store.getState() as any as IState)
                .then(res => store.dispatch({ type: FETCH_BOOKMAKER_OPTIONS_SUCCEDED, data: res.data, headers:res.headers }))
                .catch(error => store.dispatch({ type: FETCH_BOOKMAKER_OPTIONS_FAILED, error }));
            break;
        case FETCH_BOOKMAKER_OPTIONS_SUCCEDED:
            const state : IState = store.getState() as any as IState;
            Promise.all( [
                // wait with promisechain for timingsWebWorker having sent data message
                new Promise<void>(resolve => {
                    timingsWebWorkerResolver ? resolve() : timingsWebWorkerResolver = resolve
                }),
                promiseTranslations(state),
            ] )
            .then( (responses: any[]) => {
                store.dispatch( { type: FETCH_TRANSLATIONS_SUCCEEDED, data: responses[1].data, headers: responses[1].headers } );

                const state : IState = store.getState() as any as IState;

                addStyles( [
                    `${getSkinningsUrl(state)}vti/Default/css/style.css`,
                    `${getSkinningsUrl(state)}clients/${getStyle(state)}/css/client-colors.css`,
                ], document.head);

                const matchIds = getMatchIds(state);

                const matchFeedPromises: Promise<any>[] = [];

                // call match events feed for each matchid
                for (let matchId of matchIds) {
                    matchFeedPromises.push( fetchInitialMatchFeedBatch(store as any,matchId) );
                }

                Promise.all( matchFeedPromises )
                    .then( () => store.dispatch( {type: INIT_APPLICATION_FINISHED} ) );

            } )
            .catch( error => {
                console.error( 'Initialization failed', error );
                store.dispatch( { type: INIT_APPLICATION_FAILED, error } )
            } );
            break;
        case FETCH_BOOKMAKER_OPTIONS_FAILED:
            const error = new Error('No bookmaker options');
            console.error( 'Initialization failed', error );
            store.dispatch( { type: INIT_APPLICATION_FAILED, error } )
            break;
        case INIT_APPLICATION_FAILED:
            document.location.reload();
            break;
    }
    return result;
}


const fetchInitialMatchFeedBatch = (store:MiddlewareAPI<IState>,matchId:number) : Promise<any> =>  {
    // TODO resolve this promise chain via actions
    return new Promise<void>( (resolve, reject) =>
        promiseMatchEvents(store.getState(),matchId)
            .then( response => {
                store.dispatch( { type: FETCH_MATCH_EVENTS_SUCCEEDED, data: response.data, headers:response.headers } );

                const state = store.getState();

                const tournamentId = getTournamentId(state);
                const tournamentIdUnique = getUniqueTournamentId(state);
                const clubIds = getPlayerUidsByMatchId(state,matchId);
                const channelId = getChannelIdByMatchId(state,matchId);

                const feedBatch = new FeedBatch();

                feedBatch.addFeed( FETCH_MATCH_ODDS_SUCCEEDED, promiseMatchOddsValidated(state, matchId) );

                if (clubIds.home && clubIds.away) {
                    if( channelId == getActiveChannelId(state) || getPollInactiveChannels(state) ) {
                        // These don't need to be synchronized
                        store.dispatch( { type: FETCH_STATS_RANKING_REQUESTED, tournamentId } )
                        store.dispatch( { type: FETCH_STATS_PLAYER_AGGREGATE_REQUESTED, tournamentId: tournamentIdUnique, teamIdA: clubIds.home, teamIdB: clubIds.away, matchId, channelId } )
                        store.dispatch( { type: FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED, teamIdA: clubIds.home, teamIdB: clubIds.away, channelId } )
                        store.dispatch( { type: FETCH_STATS_TEAM_LAST_X_REQUESTED, teamIdA: clubIds.home, teamIdB: clubIds.away, channelId } )
                    }
                } else {
                    store.dispatch({ type: INIT_APPLICATION_FAILED });
                }
                if( channelId == getActiveChannelId(state) ) {
                    feedBatch.addFeed(FETCH_MATCH_DETAILS_EXTENDED_SUCCEEDED,promiseMatchDetailsExtended(state,matchId));
                }

                feedBatch.all( store.dispatch )
                    .then( ( responses: any ) => {
                        resolve();
                    } )
                    .catch( error => {
                        store.dispatch({ type: INIT_APPLICATION_FAILED });
                        reject(error);
                    } )
            }
        )
    );
}



export default initializerMiddleware;
